import React from 'react'
import styled from 'styled-components'
import { Flex } from 'components/styled/containers/flex'
import { H2, Subtitle } from 'components/styled/typography'

interface SmallHeaderContentProps {
  title: string
  status?: React.ReactNode
  description?: string
}

const SmallHeaderWrapper = styled(Flex)`
  flex-direction: column;
  max-width: 100%;
`

export const SmallHeaderContent = ({
  title,
  description,
  status,
}: SmallHeaderContentProps) => (
  <SmallHeaderWrapper justifyContent="center" alignItems="center">
    <H2 ellipsis numberOfLines={2} mb="s4" textAlign="center">
      {title}
    </H2>
    {description && (
      <Subtitle
        color="headerText"
        textAlign="center"
        fontWeight={400}
        numberOfLines={1}
        mt="s8"
      >
        {description}
      </Subtitle>
    )}
    {status && (
      <Subtitle mt="s8" color="white">
        {status}
      </Subtitle>
    )}
  </SmallHeaderWrapper>
)
